import ReactDropdown from "react-dropdown"
import 'react-dropdown/style.css'

// eslint-disable-next-line import/no-anonymous-default-export
export default function Dropdown(props){
    return(
        <ReactDropdown options={props?.options} value={props?.value} onChange={props?.onChange} className={props?.className} placeholder={props?.placeholder} disabled={props?.disabled} />
    )
}

// export default function Dropdown(props){
//     return(
//         <select className="px-2 py-2 border rounded" value={props?.value} onChange={props?.onChange}>
//             {props?.options?.map((data, i) => (
//                 <option key={i} value={data.value}>{data.label}</option>
//             ))}
//         </select>
        
//     )
// }